export default "__VITE_ASSET__oLfSm0ix__"